import React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@mui/material";

import { type MachineGroupConfiguration } from "@/schemas";
import { useCreateMachineGroup } from "@/hooks/machine-groups";

import { MachineGroupsConfigurationModal } from "../machine-groups-configuration-modal";

export const MachineGroupNewButton: React.FC = () => {
	const [showNew, setShowNew] = React.useState(false);
	const { mutate: createMachineGroupAsync, error } = useCreateMachineGroup();

	const handleSubmit = async (data: MachineGroupConfiguration): Promise<void> => {
		try {
			await createMachineGroupAsync(data);
			setShowNew(false);
		} catch {
			/* Handled */
		}
	};

	return (
		<>
			<MachineGroupsConfigurationModal
				open={showNew}
				onClose={() => setShowNew(false)}
				onSubmit={handleSubmit}
				error={error}
			/>
			<Button
				variant="contained"
				onClick={() => setShowNew(true)}
				data-testid="machine-group-new-button__button__open-modal"
				data-pendoid="machine-groups__button__new"
			>
				<FormattedMessage id="New Machine Group" defaultMessage="New Machine Group" />
			</Button>
		</>
	);
};
